import { media, Navbar } from '@prenuvo/shared-library';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { TableProvider } from '../contexts';
// hooks
import { useAuth } from '../hooks';

// ----------------------------------------------------------------------

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1;
  justify-content: space-between;
  height: auto;
`;

const MainWrapper = styled.div`
  padding: 0;
`;

const Wrapper = styled.div`
  max-width: 1440px;
  margin: 0 auto;

  ${media.xsmall} {
    padding: 0 16px;
  }
`;

// ----------------------------------------------------------------------

const MainLayout = () => {
  const { user } = useAuth();

  return (
    <Container>
      <Navbar onLogoClick={() => {}} user={user as any} />

      <MainWrapper>
        <TableProvider>
          <Wrapper>
            <Outlet />
          </Wrapper>
        </TableProvider>
      </MainWrapper>
    </Container>
  );
};
export default MainLayout;
